module.exports = __webpack_public_path__ + "media/images/posts/zoom-calls-3383e7b160352241daae5ab3fda4acfc.jpg";